const tabs = {
  init() {
    this.setTabs();
  },

  setTabs() {
    document.addEventListener('click', (event) => {
      const tab = (event.target as HTMLElement).closest<HTMLElement>('[data-tab]');

      if (!tab) return;

      const groupName = tab.dataset.tab;

      if (!groupName) return;

      const tabs = document.querySelectorAll<HTMLElement>(`[data-tab="${groupName}"]`);
      const contents = document.querySelectorAll<HTMLElement>(`[data-tab-body="${groupName}"]`);

      const index = Array.from(tabs).indexOf(tab);

      tabs.forEach((item, itemIndex) => {
        item.classList.remove('activeClass');
        contents[itemIndex]?.classList.remove('activeClass');
      });

      tab.classList.add('activeClass');
      contents[index]?.classList.add('activeClass');
    });
  }
};

export default tabs;